<template lang="pug">
div
    RoleSelect(v-if="loaded")
    div(v-if="allowedRoles.includes(login_user.role)")
        h1 Assign Case Manager
        b-card.border-0
            b-form(@submit.prevent="assignCaseManager")
                b-form-group(label="Case Manager Assign Excel File:")
                    b-form-file(@change="processCMAssignFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" required)
                b-form-group
                    b-button(type="submit" :disabled="(isSubmitting) || (!CMCaseJson)") {{ isSubmitting ? 'Importing...' : 'Import'}}

                b-spinner.mr-2(v-if="isSubmitting" small variant="secondary" label="Spinning")
                span(v-if="isSubmitting") Importing {{currentRow}} of {{totalRow}} data
                
                div(v-for="errMsg in errorLog")
                    div.text-danger
                        b-icon.mr-1(icon="exclamation-triangle")
                        | {{errMsg}}
    div(v-else)
        p.my-4 You're not allowed to view this page as {{login_user.role.replace(/_/g, ' ')}}
</template>

<script>
import dayjs from 'dayjs';
import RoleSelect from '@/components/roleSelect.vue';
import XLSX from 'xlsx';

export default {
    components: {
        RoleSelect,
    },
    computed: {
        loaded(){
            return this.$store.state.loaded;
        },
        login_user(){
            return this.$store.state.login_user;
        },
    },
    data(){
        return{
            allowedRoles:['admin'],
            isSubmitting: false,
            CMCaseJson: null,
            totalRow: 0,
            currentRow: 0,
            errorLog: []
        }
    },
    methods: {
        dayjs,
        processCMAssignFile(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return false;

            let file = files[0];

            var reader = new FileReader();
            reader.readAsArrayBuffer(file);

            let vm = this;

            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, {type: 'array'});
                let sheetName = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[sheetName];

                vm.CMCaseJson = XLSX.utils.sheet_to_json(worksheet);
            };
        },
        async getUserIdByEmail(email) {
            if(!email) {return false;}

            return await this.$store.dispatch('getUserByEmail', email).then((result)=>{
                return result?.graph_id || false;
            }).catch(()=>{
                return false;
            })
        },
        async getCaseByRefId(refId) {
            if(!refId) {return false;}

            return await this.$store.dispatch('getCaseByRefId', refId).then((result)=>{
                if(result.value.length > 0)
                    return result.value[0];
                else
                    return false;
            }).catch(()=>{
                return false;
            })
        },
        async setCaseManager(caseId, caseManagerId) {
            if(!caseId && !caseManagerId) {return false;}

            return await this.$store.dispatch('editCase', { caseId:caseId, payload:{new_casemanager:caseManagerId} }).then((result)=>{
                return result;
            }).catch(()=>{
                return false;
            })
        },
        async assignCaseManager() {
            this.isSubmitting = true;
            this.errorLog = [];
            this.currentRow = 0;
            this.totalRow = 0;

            // check if this json exist
            if(!this.CMCaseJson) {
                return false;
            }

            this.totalRow = this.CMCaseJson.length;
        
            for(let cm of this.CMCaseJson) {
                this.currentRow += 1;

                //console.log(cm);

                // GET case obj where refId match
                let caseObj = await this.getCaseByRefId((cm?.["Case Number"]) ? cm["Case Number"].trim().replace(/['"]+/g, '') : null);
                // If none match add to error log message and stop proceeding to next line (continue)
                if(!caseObj) {
                    this.errorLog.push(`No matching case found in the database for the reference id ${cm?.["Case Number"]}`);
                    continue;
                }

                /*** Get case manager from CMCaseJson and match with a user in certainty db ***/
                // GET user where email = case manager email
                if(!cm?.["Email of CM"]){ // if none, skip iteration
                    this.errorLog.push(`Missing case manager for ${cm?.["Case Number"]} in cm File`)
                    continue;
                }

                let caseManagerId = await this.getUserIdByEmail(`nhcs-${cm?.["Email of CM"]}`);
                if(!caseManagerId) {
                    this.errorLog.push(`Case manager nhcs-${cm?.["Email of CM"]} for ${cm?.["Case Number"]} not found in the database`)
                    continue;
                }

                //console.log(`nhcs-${cm?.["Email of CM"]} = ${caseManagerId}\n${cm?.["Case Number"]} = ${caseObj?.new_referencenumber}`);

                // PATCH case obj with new case manager
                await this.setCaseManager(caseObj?.new_caseid, caseManagerId);
            }

            //console.log(this.errorLog);
           
            this.isSubmitting = false;
        }
        
    }
}
</script>

<style>

</style>